import {urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        const tab = this.$parent.$props.tabs.find(e => e.component === 'app-hotel-option')
        return {
            urlGenerator,
            options: {
                name             : this.$t('option'),
                url              : `${TENANT_BASE_URL}app/hotel/option?hotel_id=${tab.hotel.id}`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('name'),
                        type     : 'text',
                        key      : 'name',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'text',
                        key      : 'type_name',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('selling_price'),
                        type     : 'text',
                        key      : 'selling_price',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('contract_price'),
                        type     : 'text',
                        key      : 'contract_price',
                        isVisible: true,
                    },
                ],
                filters          : [],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_hotel_option')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/hotel/option`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_hotel_option')
                    }
                ],
            }
        }
    },
}